"use client";

import MarkdownRenderer from "@/components/markdown-renderer";
import React from "react";

export default function ContentWrapper({ content }: { content: string }) {
  return (
    <MarkdownRenderer content={content} className="text-base sm:text-lg leading-relaxed focus:outline-none" enableDocsFeatures={false} />
  );
}
